
import {
  Mixins,
  Component,
  Watch,
} from 'vue-property-decorator';
import {
  Dialog,
  Button,
  Pagination,
  Select,
  Option,
} from 'element-ui';

import {
  tSearch,
} from '@/components/Search/index';
import {
  IBTNCONF,
} from '@/types/base.d';
import tableMixin from './tableMixin';
import addOrModify from './components/addOrModify.vue';
import searchForm from './components/searchForm.vue';
@Component({
  components: {
    Dialog,
    Button,
    Pagination,
    tSearch,
    addOrModify,
    Select,
    Option,
    searchForm,
  },
})

export default class questionsManage extends Mixins(tableMixin) {
  private actionBtns: Array < IBTNCONF > = [{
    title: '新增',
    name: '/ques/manage:add',
    icon: 'plus',
    callback: this.handleAddQuestion,
    log: {
      name: '题库 - 新增',
      component: '/ques/manage:add',
    },
  }];

  private isNeedAddOrModify = false;

  private echoData = {};

  private searchValue: string = '';

  public $refs!: {
    searchForm: searchForm,
  }

  // '0': 有效 '1' 作废
  private status = '0'

  mounted() {
    this.init()
    this.getData({ status: this.status });
  }

  editItem(rowData: any) {
    this.showOrCloseAdd();
    this.echoData = rowData;
  }

  handleAddQuestion() {
    this.echoData = {};
    this.showOrCloseAdd();
  }

  showOrCloseAdd() {
    this.isNeedAddOrModify = !this.isNeedAddOrModify;
  }

  closeAddAndRefresh() {
    this.showOrCloseAdd();
    this.getData({ status: this.status });
  }

  handleSearchChange(v) {
    this.getData({ status: this.status, serial: v });
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索普通搜索切换事件
   * @param { boolean } activate 是否切换
   */
  handleActivateChange(activate: boolean) {
    if (activate) {
      this.$refs.searchForm.setTitle(this.searchValue);
      this.searchValue = '';
    } else this.searchValue = this.$refs.searchForm.getFormData().serial;
  }

  // 搜索提交事件
  handleAdvancedSearch() {
    const form: any = this.$refs.searchForm.getFormData();
    const params: any = {
      serial: form.serial,
      status: form.status,
    };
    this.status = params.status
    this.getData(params);
  }

  // 搜索清空事件
  handleAdvanceClear() {
    this.status = '0'
    this.$refs.searchForm.handleClear();
    this.getData({ status: this.status });
  }
}
